"use client"

import { useRouter, useSearchParams } from "next/navigation"
import { LayoutGrid, List } from "lucide-react"
import { cn } from "@/lib/utils"
import { useCatalogTransition } from "@/components/public/CatalogTransitionContext"
import { useTranslations } from "@/lib/i18n/client"

export function CatalogViewToggle() {
  const { t } = useTranslations()
  const router = useRouter()
  const searchParams = useSearchParams()
  const { startViewTransition, isPending, pendingView } = useCatalogTransition()
  const currentView = searchParams.get("view") ?? "grid"
  const activeView = (isPending && pendingView) ? pendingView : currentView

  function setView(view: string) {
    const params = new URLSearchParams(searchParams.toString())
    if (view === "grid") {
      params.delete("view")
    } else {
      params.set("view", view)
    }
    startViewTransition(view, () => {
      router.push(`/aeronaves?${params.toString()}`)
    })
  }

  return (
    <div role="group" aria-label={t.catalog.viewToggle} className="flex items-center gap-2 rounded-lg border-[0.5px] border-slate-200 p-0.5">
      <button
        type="button"
        onClick={() => setView("grid")}
        className={cn(
          "inline-flex items-center justify-center rounded-md p-2.5 transition-colors",
          activeView === "grid"
            ? "bg-navy-50 text-navy-800"
            : "text-slate-500 hover:text-slate-600",
        )}
        aria-label={t.catalog.gridView}
        aria-pressed={activeView === "grid"}
      >
        <LayoutGrid className="h-4 w-4" aria-hidden="true" />
      </button>
      <button
        type="button"
        onClick={() => setView("list")}
        className={cn(
          "inline-flex items-center justify-center rounded-md p-2.5 transition-colors",
          activeView === "list"
            ? "bg-navy-50 text-navy-800"
            : "text-slate-500 hover:text-slate-600",
        )}
        aria-label={t.catalog.listView}
        aria-pressed={activeView === "list"}
      >
        <List className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  )
}
